import React from 'react';
import { Typography } from '@ntuctech/devex-tangram';
import { ButtonOutlined } from '@ntuctech/devex-tangram/Button';
import styled from 'styled-components';
import OGPromos from '../icons/img/OGpromos.png';
import NewUser from '../icons/img/newuser.png';
import Gifting from '../icons/img/Gifting.png';
import { SCREEN_SIZE } from '../../lib/mediaQuery';
import { getEcommVoucherLink } from '../../lib/utils';

const TitleContainer = styled.div`
  margin: 2rem 0;
  text-align: center;
  h2 {
    font-style: normal;
    font-weight: 700;
    font-size: 1.438rem;
    line-height: 2rem;
    text-align: center;
    color: #333333;
  }
`;

const EcommCard = styled.div`
  padding: 1rem;
  border-radius: 1rem;
  border: 0.063rem solid var(--Colour-Mineshaft-80, #eaeaea);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 20.438rem;
  .banner-title-text {
    margin-bottom: 0.25rem;
  }

  .ecomm-button {
    padding: 0.5rem 1rem;
    width: max-content;
  }

  .banner-title {
    margin-top: 1rem;
    margin-bottom: 0.75rem;
    flex-grow: 1;
  }
  .button-text {
    color: #1454b8;
  }
  .img-banner {
    width: 100%;
    height: 100%;
    flex-shrink: 0;
    border-radius: 0.5rem;
    ${SCREEN_SIZE.Below.MobileL} {
      border-radius: 0.5rem;
      width: 12.5rem;
      height: 8.313rem;
    }
  }
  button {
    margin: 0;
  }

  ${SCREEN_SIZE.Below.MobileL} {
    width: 14.5rem;
    height: 20.813rem;
    display: flex;
    flex-direction: column;
    min-height: 20rem;
  }
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.25rem;
  ${SCREEN_SIZE.Below.MobileL} {
    margin: 0;
    padding: 0 1rem;
    gap: 0.75rem;
    display: flex;
    overflow-x: scroll;
    max-width: 100%;
    ::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none;
  }
`;

const BannerContainer = styled.div`
  padding: 0;
  border-radius: 0.5rem;
  max-width: 13.75rem;
  cursor: pointer;

  ${SCREEN_SIZE.Below.MobileL} {
    max-width: 100%;
  }
`;

const EcommBanner = () => {
  const bannerList = [
    {
      id: 0,
      title: 'Bigger bang for your buck',
      description: 'Up to 50% off your daily essentials.',
      image: OGPromos.src,
      buttonText: 'Browse promos',
      url: getEcommVoucherLink('Browse promos'),
    },
    {
      id: 1,
      title: 'New to online grocery?',
      description: 'Start today to enjoy $10 off $59 spend.',
      image: NewUser.src,
      buttonText: 'Shop now',
      url: getEcommVoucherLink('Shop now'),
    },
    {
      id: 2,
      title: 'Gifting made easy',
      description: 'Send a FairPrice E-Gift Voucher to a loved one.',
      image: Gifting.src,
      buttonText: 'Pick a design',
      url: 'https://www.gift.fairprice.com.sg/',
    },
  ];

  return (
    <>
      <TitleContainer>
        <h2>More ways to shop</h2>
      </TitleContainer>

      <GridContainer>
        {bannerList.map((banner) => (
          <BannerContainer
            data-testid={`banner-${banner.id}`}
            key={`${banner.title}-${banner.id}`}
            onClick={() => {
              window.open(banner.url, '_blank');
            }}
          >
            <EcommCard>
              <img src={banner.image} alt="banner" className="img-banner" />
              <div className="banner-title">
                <Typography variant="titleM" className="banner-title-text">
                  {banner.title}
                </Typography>
                <Typography variant="bodyS">{banner.description}</Typography>
              </div>

              <ButtonOutlined
                size="s"
                className="ecomm-button"
                data-testid={`banner-btn-${banner.id}`}
                onClick={() => {
                  window.open(banner.url, '_blank');
                }}
              >
                <Typography variant="bodyMBold" className="button-text">
                  {banner.buttonText}
                </Typography>
              </ButtonOutlined>
            </EcommCard>
          </BannerContainer>
        ))}
      </GridContainer>
    </>
  );
};

export default EcommBanner;
